
import React, { Component, useEffect, useState } from 'react'
import { BrowserRouter as Router, Route, Link, withRouter} from 'react-router-dom';
import logo from './CampusVRLogo.jpg'; 

import UserPage from './UserPage.js';
import HomePage from './HomePage.js';



class Home extends React.Component {
    constructor(){
      super();
      this.state = {
      };
      this.routeChange = this.routeChange.bind(this);
    }

    

    routeChange = (e) =>{
      console.log(e.target.id);
      let path = '';
      switch(e.target.id){
        case "login":
          path = 'user';
          break;
        case "join":
          path = 'screenshare';
          break;
      }
      this.props.history.push(path);
    }

    render(){
        return (
          <div className="App">
            <header className="App-header">
            </header>
            
            <img src={logo} width="100vw"/>
                <div>
                    <button id="login" onClick={this.routeChange}>Login</button>
                </div>
          </div>
        );
      }
}

export default withRouter(Home);